<template>
  <div>
    <div
      id="modal-title"
      class="modal-header"
    >
      <h3>Editar Notifiers</h3>
    </div>
    <div class="modal-content">
      <form id="form-edit-notifier">
        <div class="input-group">
          <div>
            <h4>{{ notifier.serviceID }}</h4>
          </div>
          <div
            v-for="hook in notifier.webHooks"
            :key="hook.id"
          >
            <div class="input input-text">
              <label :for="hook.channel">Canal</label>
              <input
                :id="hook.channel"
                v-model="hook.channel"
                type="text"
              >
            </div>
            <div class="input input-text">
              <label :for="hook.id">WebHook</label>
              <input
                :id="hook.id"
                v-model="hook.id"
                type="text"
              >
            </div>
          </div>
        </div>
        <div class="form-actions">
          <button
            type="button"
            class="btn-secondary"
            @click="close"
          >
            {{ $t('cancel') }}
          </button>
          <button
            type="button"
            class="btn-primary btn-active main-action"
            @click="editNotifier()"
          >
            {{ $t('update') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import notifiersAPI from '@/api/notifiers'
export default {
  name: 'EditDevice',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    notifier: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    ...mapState(['services'])
  },
  created () {
    this.fetchNotifiers()
  },
  methods: {
    ...mapActions([
      'fetchNotifiers'
    ]),
    async close () {
      this.$emit('input', false)
    },
    async editNotifier () {
      console.log(this.notifier)
      notifiersAPI.updateNotifier(this.notifier)
      this.fetchNotifiers()
      await this.close()
    }
  }
}
</script>
